module.exports = __webpack_public_path__ + "static/moneyBack-0a0717a6a7bfe7d3e135d34600213c40.svg";